import { createReducers, createActions, request } from '../../../utils/';
import { combineReducers } from 'redux';
import Urls from '../../../../config/index';
import { message } from 'antd';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

const { MonitorUrl } = Urls;

const path = name => `app/pages/pie/${name}`;
const models = {
    searchValues: {
        data: {
            date: moment().format('YYYY-MM-DD'),
        },
        handlers: {
            changeTaskDeviceSearchValues(state, action) {
                return action.payload;
            },
        },
    },
    getTest:{
        data: [],
        handlers: {
            getTestFn(state, action) {
                return action.payload;
            },
        },
    },
    deviceInfo:{
        data: [],
        handlers: {
            getDeviceInfo(state, action) {
                return action.payload;
            },
        },
    },
    taskDeviceInfo:{
        data: [],
        handlers: {
            getTaskDeviceInfo(state, action) {
                return action.payload;
            },
        },
    },
    checkPvGap:{
        data: [],
        handlers: {
            getCheckPvGap(state, action) {
                return action.payload;
            },
        },
    },
    errorRate:{
        data: [],
        handlers: {
            getErrorRateFn(state,action){
                return action.payload;
            }
        }
    },
    allDataSize:{
        data: [],
        handlers: {
            getAllDataSize(state,action){
                return action.payload;
            }
        }
    },
    dataSize:{
        data: [],
        handlers: {
            getDataSize(state,action){
                return action.payload;
            }
        }
    },
    errorRateChart:{
        data: [],
        handlers: {
            getErrorRateChartFn(state,action){
                return action.payload;
            }
        }
    },

    list: {
        data: [],
        handlers: {
            changeStatus(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
            get(state, action) {
                return action.payload;
            },
            add(state, action) {
                return [...action.payload, ...state];
            },
            del(state, action) {
                return state.filter(item => item._id !== action.payload);
            },
            update(state, action) {
                return state.map(item => (item._id === action.payload._id ? action.payload : item));
            },
        },
    },
    blockingTaskMonitorQuery: {
        data: [],
        handlers: {
            getBlockingTaskMonitorQuery(state,action){
                return action.payload;
            }
        }
    },
    // selectedContent: {
    //     data: [],
    //     handlers: {
    //         getSele(state, action) {
    //             return action.payload;
    //         },
    //     },
    // },
    // listAll: {
    //     data: [],
    //     handlers: {
    //         getAll(state, action) {
    //             return action.payload;
    //         },
    //     },
    // },
    // transferData: {
    //     data: {
    //         selectedRowKeys: [],
    //     },
    //     handlers: {
    //         getTransferData(state, action) {
    //             return { ...state, ...action.payload };
    //         },
    //     },
    // },
    // pagination: {
    //     data: {
    //         current: 1,
    //         total: 0,
    //         pageSize: 10,
    //     },
    //     handlers: {
    //         changePagination(state, action) {
    //             return {
    //                 ...state,
    //                 ...action.payload,
    //             };
    //         },
    //     },
    // },
    // searchValues: {
    //     data: {},
    //     handlers: {
    //         changeSearchValues(state, action) {
    //             return action.payload;
    //         },
    //     },
    // },
    uiStatus: {
        data: {
            isLoading: false,
            isUpdateShow: false,
            isSendCommend: false,
            isLoadingAllProxyPoolLength: false,
            isLoadingDeviceInfo: false,
            isLoadingErrorRate: false,
            isLoadingAllDataSize: false,
            isLoadingDataSize: false,
            isLoadingErrorRateChart: false,
            isLoadingTaskDeviceInfo: false,
            isLoadingBlockingTaskMonitorQuery: false,
        },
        handlers: {
            changeUiStatus(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    // currentSelectId: {
    //     data: '',
    //     handlers: {
    //         changeCurrentSelectId(state, action) {
    //             return action.payload;
    //         },
    //     },
    // },
};

export const actions = createActions(models, path);

export default combineReducers(createReducers(models, path));


/**
 * 获取订单列表数据
 */
export const asyncGet = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoadingAllProxyPoolLength: true,
                }),
            );
            console.log(getState())
            // 下面的请求和结果返回需要根据接口来实现
            let list = await request(MonitorUrl.getAllProxyPoolLength, 'GET');
            dispatch(actions.get(list));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoadingAllProxyPoolLength: false,
                }),
            );
        }
    };
};

/**
 * 获取设备号信息 地区维度
 */
export const getDeviceInfo = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoadingDeviceInfo: true,
                }),
            );
            // 下面的请求和结果返回需要根据接口来实现
            let map = await request(MonitorUrl.getDeviceInfoUrl, 'GET');
            let deviceInfo = new Array();
            for(let k of Object.keys(map)){
                let arr = Array.from(map[k]);
                arr.map((item)=>{
                    deviceInfo.push(item);
                });
            };
            let compare = (property) =>{
                return function(a,b){
                    var value1 = a[property];
                    var value2 = b[property];
                    return value2 - value1;
                }
            };
            deviceInfo.sort(compare('length'));
            dispatch(actions.getDeviceInfo(deviceInfo));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoadingDeviceInfo: false,
                }),
            );
        }
    };
};
export const getCheckPvGap = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoadingCheckPvGap: true,
                }),
            );
            // 下面的请求和结果返回需要根据接口来实现
            let map = await request(MonitorUrl.checkPvGap, 'GET');
            map.map((item,index)=>{
                item.key=index;
                return item;
            });
            dispatch(actions.getCheckPvGap(map));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoadingCheckPvGap: false,
                }),
            );
        }
    };
};

/**
 * 获取设备号信息 任务维度
 */
export const getTaskDeviceInfo = (date) => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoadingTaskDeviceInfo: true,
                }),
            );
           /* if( date === '' || date === undefined){
                let nowDate = new Date();
                let year = nowDate.getFullYear();
                let month = nowDate.getMonth() + 1 < 10 ? "0" + (nowDate.getMonth() + 1)
                    : nowDate.getMonth() + 1;
                let day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate
                    .getDate();
                date = year + "-" + month + "-" + day;
            }*/
           let date = formatGetParams(getState);
           date = date['date'];
            // 下面的请求和结果返回需要根据接口来实现
            let list = await request(MonitorUrl.getTaskDeviceInfo+'?date='+date, 'GET');
            list = list.map((item,index) => {
                item.key1=item.key;
                item.key = index;
                return item;
            });
            dispatch(actions.getTaskDeviceInfo(list));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoadingTaskDeviceInfo: false,
                }),
            );
        }
    };
};
const formatGetParams = getState => {
    const state = getState().pie;
    const searchValue = state.searchValues || {};

    const params = {
        ...searchValue,
    };
    return params;
};
/*export const getTestA = () =>{
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoadingErrorRate: true,
                }),
            );
            // 下面的请求和结果返回需要根据接口来实现
            let getTest = await request(MonitorUrl.errorRate, 'GET');
            dispatch(actions.getTestFn(getTest));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoadingErrorRate: false,
                }),
            );
        }
    };
};*/
export const getBlockingTaskMonitorUrl = () => {
    return async (dispatch,getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoadingBlockingTaskMonitorQuery: true,
                }),
            );

            // 下面的请求和结果返回需要根据接口来实现
            let blockingTaskMonitorQuery = await request(MonitorUrl.getBlockingTaskMonitor, 'GET');
            dispatch(actions.getBlockingTaskMonitorQuery(blockingTaskMonitorQuery));
            console.log(getState())
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoadingBlockingTaskMonitorQuery: false,
                }),
            );
        }
    }
};

export const getErrorRate = () =>{
    return async (dispatch,getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoadingErrorRate: true,
                })
            );
            let errorRateData = await request(MonitorUrl.errorRate,'GET');
            dispatch(actions.getErrorRateFn(errorRateData));
        } catch (e){
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoadingErrorRate: false,
                })
            )
        }
    }
};
export const getAllDataSize = () =>{
    return async (dispatch,getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoadingAllDataSize: true,
                })
            );
            let allDataSize = await request(MonitorUrl.allDataSize,'GET');
            dispatch(actions.getAllDataSize(allDataSize));
        } catch (e){
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoadingAllDataSize: false,
                })
            )
        }
    }
};
export const getDataSize = () =>{
    return async (dispatch,getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoadingDataSize: true,
                })
            );
            let dataSize = await request(MonitorUrl.dataSize,'GET');
            dispatch(actions.getDataSize(dataSize));
        } catch (e){
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoadingDataSize: false,
                })
            )
        }
    }
};
export const getErrorRateChart = () =>{
    return async (dispatch,getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoadingErrorRateChart: true,
                })
            );
            let errorRateChart = await request(MonitorUrl.getErrorRateChart,'GET');
            dispatch(actions.getErrorRateChartFn(errorRateChart));
        } catch (e){
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoadingErrorRateChart: false,
                })
            )
        }
    }
};


export const delProxyKey = keyName => {
    return async (dispatch,getState) =>{
        try {
            dispatch(actions.changeUiStatus({ isLoading: true }));
            await request(MonitorUrl.delProxyKey + '?key=' + keyName, 'GET');
            message.success('删除成功');
            dispatch(actions.changeUiStatus({ isUpdateShow: false }));
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({ isLoading: false }));
        }
    };
};
export const asyncUpdate = contents => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({ isLoading: true }));
            // 下面的请求和结果返回需要根据接口来实现
            await request(scriptUrl.setScript, 'POST', contents);
            message.success('修改成功');
            dispatch(actions.changeUiStatus({ isUpdateShow: false }));
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({ isLoading: false }));
        }
    };
};

// 添加脚本
export const asyncAdd = contents => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({ isLoading: true }));
            // 下面的请求和结果返回需要根据接口来实现
            await request(scriptUrl.addScript, 'POST', contents);
            message.success('添加成功');
            dispatch(actions.changeUiStatus({ isUpdateShow: false }));
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({ isLoading: false }));
        }
    };
};

// 删除用户
export const delect = record => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({ isLoading: true }));
            // 下面的请求和结果返回需要根据接口来实现
            await request(scriptUrl.del, 'POST', record);
            message.success('删除成功');
            dispatch(actions.changeUiStatus({ isUpdateShow: false }));
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({ isLoading: false }));
        }
    };
};

// 删除用户组
export const delectAll = ids => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoading: true,
                }),
            );
            // 下面的请求和结果返回需要根据接口来实现
            await request(scriptUrl.delBatch, 'POST', ids);
            message.success('删除成功');
            dispatch(actions.changeUiStatus({ isUpdateShow: false }));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoading: false,
                }),
            );
        }
    };
};




// WEBPACK FOOTER //
// ./pages/monitor/name/reducers.js